import { render, staticRenderFns } from "./AppRouterTabNav.vue?vue&type=template&id=aea8db7c&scoped=true"
import script from "./AppRouterTabNav.vue?vue&type=script&lang=js"
export * from "./AppRouterTabNav.vue?vue&type=script&lang=js"
import style0 from "./AppRouterTabNav.vue?vue&type=style&index=0&id=aea8db7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea8db7c",
  null
  
)

export default component.exports